import { InMemoryCache, makeVar } from '@apollo/client';
import { CustomRoles } from '../helpers/CustomRoles';

export const cache = new InMemoryCache(
    {
        typePolicies: {
            Query: {
                fields: {
                    assignedRoles: {
                        read() {
                           return assignedRolesVar();
                          }
                    }
                }
            }
        }
    }
)

export const assignedRolesVar = makeVar([CustomRoles.Unknown]);